export default {
  registration: {
    started: {
      key: "[pfm_registration]started",
      attributes: []
    },
    signupButton_clicked: {
      key: "[pfm_registration]signupButton_clicked",
      attributes: []
    }
  },
  onboarding: {
    started: {
      key: "[pfm_onboarding]started",
      attributes: []
    },
    passcode_set: {
      key: "[pfm_onboarding]passcode_set",
      attributes: []
    }
  },
  corporate: {
    opened: {
      key: "[pfm_corporate]opened",
      attributes: []
    },
    addService_selected: {
      key: "[pfm_corporate]addService_selected",
      attributes: []
    },
    account_selected: {
      key: "[pfm_corporate]account_selected",
      attributes: ["entityKey", "categoryGroup", "category"]
    }
  },
  vault: {
    service_selected: {
      key: "[pfm_vault]service_selected",
      attributes: ["entityKey", "categoryGroup", "category"]
    },
    authAndConnect_selected: {
      key: "[pfm_vault]authAndConnect_selected",
      attributes: ["entityKey", "categoryGroup", "category"]
    },
    service_connected: {
      key: "[pfm_vault]service_connected",
      attributes: ["entityKey", "categoryGroup", "category"]
    }
  },
  expenses: {
    expensesReview_opened: {
      key: "[pfm_expenses]expensesReview_opened",
      attributes: []
    },
    expensesReview_confirm_selected: {
      key: "[pfm_expenses]expensesReview_confirm_selected",
      attributes: ["isEdited"]
    },
    claim_created: {
      key: "[pfm_expenses]claim_created",
      attributes: ["claimId"]
    },
    claimDownload_closed: {
      key: "[pfm_expenses]claimDownload_closed",
      attributes: ["claimId"]
    },
    claimDownload_selected: {
      key: "[pfm_expenses]claimDownload_selected",
      attributes: ["claimId", "downloadFormat", "isNew"]
    }
  },
  paywall: {
    paywall_opened: {
      key: "[pfm_paywall]paywall_opened",
      attributes: ["entryPoint"]
    },
    subscription_completed: {
      key: "[pfm_paywall]subscription_completed",
      attributes: ["subscriptionGroup", "subscriptionTier"]
    }
  },
  receipts: {
    receipts_opened: {
      key: "[pfm_receipts]receipts_opened",
      attributes: []
    },
    receipt_uploaded: {
      key: "[pfm_receipts]receipt_uploaded",
      attributes: ["fileSource"]
    },
    matchedReceipt_state_updated: {
      key: "[pfm_receipts]matchedReceipt_state_updated",
      attributes: ["state"]
    },
    receipt_attached: {
      key: "[pfm_receipts]receipt_attached",
      attributes: ["entryPoint"]
    }
  }
};